import { Toaster } from 'sonner';
import {
	brandPrimary,
	brandPrimaryHoverTint,
	error,
	errorLight,
	success,
	successTint,
	warningDark,
	warningLight,
} from '../../styles/colors';

export function SonnerToast({ style }: { style?: React.CSSProperties }) {
	return (
		<Toaster
			position='top-center'
			richColors
			style={
				{
					'--success-bg': successTint,
					'--success-border': success,
					'--warning-border': warningDark,
					'--warning-bg': warningLight,
					'--error-bg': errorLight,
					'--error-border': error,
					'--info-bg': brandPrimaryHoverTint,
					'--info-border': brandPrimary,
					...style,
				} as React.CSSProperties
			}
			toastOptions={{
				actionButtonStyle: {
					backgroundColor: 'transparent',
					color: 'currentcolor',
					fontWeight: 'bold',
				},
			}}
		/>
	);
}
